/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockUpdateBase } from './StockUpdateBase';
import {
    StockUpdateBaseFromJSON,
    StockUpdateBaseFromJSONTyped,
    StockUpdateBaseToJSON,
    StockUpdateBaseToJSONTyped,
} from './StockUpdateBase';
import type { StockPlanUpdateBase } from './StockPlanUpdateBase';
import {
    StockPlanUpdateBaseFromJSON,
    StockPlanUpdateBaseFromJSONTyped,
    StockPlanUpdateBaseToJSON,
    StockPlanUpdateBaseToJSONTyped,
} from './StockPlanUpdateBase';

/**
 * 
 * @export
 * @interface StockPlanUpdate
 */
export interface StockPlanUpdate {
    /**
     * 
     * @type {Array<StockPlanUpdateBase>}
     * @memberof StockPlanUpdate
     */
    body: Array<StockPlanUpdateBase>;
    /**
     * 在庫など再計算
     * @type {Array<StockUpdateBase>}
     * @memberof StockPlanUpdate
     */
    stockList: Array<StockUpdateBase>;
}

/**
 * Check if a given object implements the StockPlanUpdate interface.
 */
export function instanceOfStockPlanUpdate(value: object): value is StockPlanUpdate {
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('stockList' in value) || value['stockList'] === undefined) return false;
    return true;
}

export function StockPlanUpdateFromJSON(json: any): StockPlanUpdate {
    return StockPlanUpdateFromJSONTyped(json, false);
}

export function StockPlanUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockPlanUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'body': ((json['body'] as Array<any>).map(StockPlanUpdateBaseFromJSON)),
        'stockList': ((json['stockList'] as Array<any>).map(StockUpdateBaseFromJSON)),
    };
}

export function StockPlanUpdateToJSON(json: any): StockPlanUpdate {
    return StockPlanUpdateToJSONTyped(json, false);
}

export function StockPlanUpdateToJSONTyped(value?: StockPlanUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': ((value['body'] as Array<any>).map(StockPlanUpdateBaseToJSON)),
        'stockList': ((value['stockList'] as Array<any>).map(StockUpdateBaseToJSON)),
    };
}

